import React, { useState } from "react";
import { FaqCards } from "./FaqCards";

export const FAQ = () => {
  const FaqQuestion = [
    {
      question: "How realistic are the AI models? ",
      answer:
        "State-of-the-art, with realistic lighting, shadows, and fabric draping",
    },
    {
      question: "Can I use my own custom models or backgrounds?",
      answer:
        "Currently, you can only select from a wide range and diverse models and backgrounds. We are working on supporting custom models in the future.",
    },
    {
      question: "What are the image rights and usage permissions?",
      answer:
        "Full commercial license for any images you generate.",
    },
    {
      question: "What kind of garment photos work best?",
      answer:
        "Clear, front-facing flat-lays or mannequin shots on simple backgrounds.",
    },
    {
      question: "Does it work for all types of clothing?",
      answer:
        "Best for tops, dresses, outerwear, bottoms",
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const handleQuestionClick = (index) => {
    // Toggle the same question or open a new one
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="  p-2 rounded-2xl bg-[#EEF2F6] w-5xl flex md:flex-row flex-col justify-between gap-4 md:gap-20 overflow-hidden">
      <section className=" bg-white flex flex-col rounded-xl items-center justify-center gap-6 w-[100%] rounded-lg overflow-hidden">
        {FaqQuestion.map((card, index) => (
          <FaqCards
            key={index}
            {...card}
            isActive={activeIndex === index}
            onClick={() => handleQuestionClick(index)}
            
          />
        ))}
      </section>
    </div>
  );
};
